import {httpGet} from "../libs/http";

export const performSearch = (query, onSuccess = null, onFailure = null) => dispatch => {
    httpGet('/system/search/?q=' + query, (res) => onSuccess(res), (err) => onFailure(err));
};